import { render, staticRenderFns } from "./EmailTravelQuotation.vue?vue&type=template&id=67128ff3"
import script from "./EmailTravelQuotation.vue?vue&type=script&lang=js"
export * from "./EmailTravelQuotation.vue?vue&type=script&lang=js"
import style0 from "./EmailTravelQuotation.vue?vue&type=style&index=0&id=67128ff3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports